import React, { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { AuthProvider } from "./Components/Context/AuthContext";
import { noAuthRoutes, userRoutes } from "./Routes/AllRoutes";
import UserLayout from "./Routes/middleware/UserLayout";
import UserProtectedRoute from "./Routes/middleware/UserProtectedRoute";
import CommingSoon from "./Components/Common/CommingSoon";
import { NotificationProvider } from "./Components/Context/NotificationContext";
import { WalletProvider } from "./Components/Context/WalletContext";

const App = () => {
  const renderAuthRoutes = (routes) => {
    return routes
      .filter((r) => r.protected)
      .map((r, i) => (
        <Route
          key={i}
          path={r.path}
          element={
            <UserProtectedRoute>
              <UserLayout>{r.component}</UserLayout>
            </UserProtectedRoute>
          }
        />
      ));
  };

  const renderNonAuthRoutes = (routes) => {
    return routes
      .filter((r) => !r.protected)
      .map((r, i) => (
        <Route
          key={i}
          path={r.path}
          element={<UserLayout>{r.component}</UserLayout>}
        />
      ));
  };

  const ServiceWorkerHandler = () => {
    const navigate = useNavigate();

    useEffect(() => {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.addEventListener("message", (event) => {
          const { type, url } = event.data || {};

          if (type === "NAVIGATE" && url) {
            navigate(url);
          }
        });
      }
    }, [navigate]);

    return null;
  };

  return (
    <React.Fragment>
      <AuthProvider>
        <NotificationProvider>
          <WalletProvider>
            <BrowserRouter>
              <ServiceWorkerHandler />
              <div className="font-Urbanist bg-[#FFFCFC] tracking-wide">
                <Routes>
                  {/*  USER PUBLIC (NO AUTH CHECK) */}
                  {renderNonAuthRoutes(userRoutes)}
                  {noAuthRoutes.map((route, idx) => (
                    <Route
                      path={route.path}
                      element={route.component}
                      key={idx}
                    />
                  ))}
                  {/*  USER PROTECTED */}
                  {renderAuthRoutes(userRoutes)}
                  <Route
                    path="*"
                    element={
                      <UserLayout>
                        <CommingSoon />
                      </UserLayout>
                    }
                  />
                </Routes>
                <Toaster position="top-center"></Toaster>
              </div>
            </BrowserRouter>
          </WalletProvider>
        </NotificationProvider>
      </AuthProvider>
    </React.Fragment>
  );
};

export default App;
